export const BENEFICIARY = 'Beneficiary';
export const ACTIVE_DUTY = 'Active Duty';
export const RESERVE_DUTY = 'Reserve Duty';
export const RETIREE = 'Retiree';
export const CIVILIAN_STAFF = 'Civilian Staff';
export const VA_PROVIDER = 'VA Provider';
export const VA_ADMIN_CHAP = 'VA Admin / Chap';
export const MED_RECRUITER = 'Medical Recruiter';
